import { TFunction } from 'i18next';
import { Heart } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { Tag } from 'shared/types/tag';

export type Options = {
  t: TFunction;
};

export const createTagFilter = (
  tags: Tag[],
  { t }: Options,
): FilterSelectOption[] =>
  tags.length
    ? [
        {
          id: FilterOptionKeys.Tag,
          label: t('context-menus.filtering.task.filters.tags.title'),
          placeholder: t('general.labels.select'),
          icon: Heart,
          type: FilterOptionType.MultiSelect,
          selectOptions: tags.map((tag) => ({
            label: tag.name,
            value: tag.id,
          })),
        },
      ]
    : [];
